import React from 'react';
import styled from 'styled-components';const GridWrapper = styled.div`
  display: grid;
  grid-gap: 10px;
  margin-top: 1em;
  margin-left: 6em;
  margin-right: 6em;
   position: absolute !important;
        top: 35%;
        left: 25%;
        right: 25%;
  grid-template-columns: repeat(12, 1fr);
  grid-auto-rows: minmax(25px, auto);
`; export const Settings = () => (
  <GridWrapper>
    <h2>Settings Heading</h2>
    <p>Settings page </p>
  </GridWrapper>
)
